import React from 'react'
import { Redirect, withRouter } from 'react-static'

import AdminEditPeople from './AdminEditPeople'
import AdminEditListen from './AdminEditListen'
import AdminSuccess from './AdminSuccess'

class AdminEdit extends React.Component {
  constructor() {
    super()
    this.state = {
      success: false,
    }
    this.errorClass = this.errorClass.bind(this)
    this.showSuccessModal = this.showSuccessModal.bind(this)
    this.successRedirect = this.successRedirect.bind(this)
  }

  renderTemplate(components) {
    const { template, data, refUrl } = this.props
    const Comp = components[template]
    return (
      <Comp
        data={data}
        refUrl={refUrl}
        errorClass={this.errorClass}
        showSuccessModal={this.showSuccessModal}
        successRedirect={this.successRedirect}
      />
    )
  }

  showSuccessModal(cb, url) {
    this.setState({ success: true }, () => {
      cb(url)
    })
  }

  successRedirect(url) {
    setTimeout(() => {
      this.props.history.replace(`/admin/${url}`)
      this.setState({ success: false })
    }, 800)
  }

  errorClass(bool) {
    return !bool ? 'is-danger' : ''
  }

  render() {
    const components = {
      people: AdminEditPeople,
      listen: AdminEditListen,
    }
    const { success } = this.state
    return (
      <div className="admin-edit">
        {this.renderTemplate(components)}
        <AdminSuccess
          type="Edit"
          className={success ? 'modal is-active' : 'modal'}
          success={success}
        />
      </div>
    )
  }
}

export default withRouter(AdminEdit)



// WEBPACK FOOTER //
// /opt/build/repo/src/components/admin/AdminEdit.js